import { render } from "./WebOrderModal.vue?vue&type=template&id=7a2b975c&scoped=true"
import script from "./WebOrderModal.vue?vue&type=script&lang=js"
export * from "./WebOrderModal.vue?vue&type=script&lang=js"

import "./WebOrderModal.vue?vue&type=style&index=0&id=7a2b975c&lang=scss&scoped=true"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2b975c"]])

export default __exports__